import React from 'react'

export default function WatchList() {
  return (
    <div>WatchList</div>
  )
}
